import { createAction } from '@reduxjs/toolkit'
import { IDashboardExample } from 'types/GlobalDashboardExample'

export const getAll = createAction('get_all_dashboard_examples')
export const getAllSuccess = createAction<{
  dashboards: IDashboardExample[]
  nr_of_customers: number
}>('get_all_dashboard_examples_success')
export const getAllFailed = createAction('get_all_dashboard_examples_failed')
